/**
 * Carte « Compte cloud » en tête de l'écran Profils. Rendu pur : reflète l'état de `account.ts`.
 * Connecté → email + sauvegarde active + déconnexion ; déconnecté → invite à se connecter.
 * Les clics sont câblés dans `main.ts`.
 */
import { currentEmail, isCloudAvailable, isLoggedIn } from '../../account';

export function renderAccountCard(): void {
  const el = document.getElementById('accountCard');
  if (!el) return;
  // Sans fournisseur configuré (build sans VITE_FIREBASE_CONFIG), le compte est indisponible.
  if (!isCloudAvailable()) {
    el.innerHTML = `<div class="acRow"><span class="acIc">👤</span><div class="acBody">
      <b>Mon compte</b><span class="acSub">Indisponible (non configuré).</span></div></div>`;
    return;
  }
  if (isLoggedIn()) {
    el.innerHTML = `<div class="acRow">
      <span class="acIc">👤</span>
      <div class="acBody">
        <b class="acEmail">${currentEmail() ?? ''}</b>
        <span class="acSub">✅ Progression sauvegardée</span>
      </div>
      <button class="btn" id="acLogout">Se déconnecter</button>
    </div>`;
  } else {
    el.innerHTML = `<div class="acRow">
      <span class="acIc">👤</span>
      <div class="acBody">
        <b>Mon compte</b>
        <span class="acSub">Sauvegarde ta progression et retrouve-la sur tous tes appareils.</span>
      </div>
      <button class="btn primary" id="acLogin">Se connecter</button>
    </div>`;
  }
}
